import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "menuIcon", "closeIcon"]

  declare readonly sidebarTarget: HTMLElement
  declare readonly menuIconTarget: HTMLElement
  declare readonly closeIconTarget: HTMLElement

  toggle() {
    const isHidden = this.sidebarTarget.classList.contains('hidden')
    
    if (isHidden) {
      this.sidebarTarget.classList.remove('hidden')
      this.sidebarTarget.classList.add('flex')
      this.menuIconTarget.classList.add('hidden')
      this.closeIconTarget.classList.remove('hidden')
    } else {
      this.sidebarTarget.classList.add('hidden')
      this.sidebarTarget.classList.remove('flex')
      this.menuIconTarget.classList.remove('hidden')
      this.closeIconTarget.classList.add('hidden')
    }
  }
}
